import React, { useEffect, useState,useRef,useContext } from "react";

import { 
  SimpleGrid, 
  Button,
  TableContainer,
  Table,
  Thead,
  Tr,
  Th,
  useToast,
  Wrap,
  WrapItem, 
  Select} from "@chakra-ui/react";
import AllusersCard from "./AllusersCard";
import { BsSearch } from "react-icons/bs";
import { IconButton, VStack, Box } from "@chakra-ui/react";

import AdminLogin from "../AdminNav/Login";
import { MyContext } from "../../MyProvider";
import { color } from "framer-motion";

import { FilterTabs, Ledger, PageHeader, Pagination, SearchField, matchesSearch } from "../../components/ui";

function Allusers() {
  const {userData,appointData,horoData,eventData}=useContext(MyContext);


  const [filter,setFilter]=useState("Users");//colored filters on top of ui
  const [counts, setCounts] = useState({
    total: 0,
    paid: 0,
    unpaid: 0,
  });

  const [appointments, setAppointments] = useState([]);
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [appointmentsPerPage] = useState(8);
  // const [totalusers, setTotalUsers] = useState(0);
  // const [update, setUpdate] = useState(false);
  const searchOption=useRef('name');//search filter
  const toast = useToast();
  
  useEffect(() => {
    
    const updatedCounts = {
      total: userData.length,      
      paid: userData.filter((ele) => ele.remainAmmount ==0).length,
      unpaid: userData.filter((ele) => ele.remainAmmount !=0).length,
    };
    setCounts(updatedCounts);


    
  }, [userData]);

  useEffect(() => {
    switch (filter) {
      case "Completed":
        setAppointments(userData.filter((ele) => ele.remainAmmount ==0));
        break;
      case "Pending":
        setAppointments(userData.filter((ele) => ele.remainAmmount !=0));
        break;
      default:
        setAppointments([...userData]);
        break;
    }  }, [filter,userData]);
 
    useEffect(()=>{
      if(currentPage!=1){setCurrentPage(1)};
    },[filter]);
      
    useEffect(()=>{
  
      if(filter!="Users"){setFilter("Users")};
      if(currentPage!=1){setCurrentPage(1)};
      if(search==""){setAppointments([...userData])}
      else if(search.length>2){setAppointments(userData.filter((el)=>matchesSearch(el,searchOption.current,search)))}
      },[search]);
   


  
  // Get current appointments based on pagination
  const indexOfLastAppointment = currentPage * appointmentsPerPage;
  const indexOfFirstAppointment = indexOfLastAppointment - appointmentsPerPage;
  const currentAppointments = appointments.slice(
    indexOfFirstAppointment,
    indexOfLastAppointment
  );

  // Change page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const goToPreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1);
    }
  };
  const goToNextPage = () => {
    if (currentPage < Math.ceil(appointments.length / appointmentsPerPage)) {
      setCurrentPage((prevPage) => prevPage + 1);
    }
  };



  const handleFilterChange = (newFilter) => {
    setFilter(newFilter);
  };


  const getHeaderStyle = (name) => ({
    cursor: "pointer",
    backgroundColor: filter === name ? "yellow" : "transparent",
    color: filter === name ? "black" : "white"
  });


  
  const token = localStorage.getItem("AdminToken");
  if (!token) {
    return <AdminLogin />;
  }
  return (
    <>
      <PageHeader title="Users" subtitle="Everyone who has booked, with what they owe">
        <SearchField
          options={[{ value: "name", label: "Name" }, { value: "phone", label: "Mobile" }]}
          onFieldChange={(event)=>{searchOption.current=event.target.value;}}
          onSearch={(e) => setSearch(e.target.value)}
        />
      </PageHeader>
      <FilterTabs
        active={filter}
        onChange={handleFilterChange}
        tabs={[
          { key: "Users", label: "All", count: counts.total },
          { key: "Pending", label: "Unsettled", count: counts.unpaid },
          { key: "Completed", label: "Settled", count: counts.paid },
        ]}
      />
      <Ledger
        columns="minmax(0,2fr) repeat(3, 90px) repeat(3, minmax(0,1fr)) 80px"
        heads={["Name", "Appts", "Astro", "Events", "Total", "Settled", "Unsettled", ""]}
        isEmpty={appointments.length === 0}
        emptyText="No users here. Try another filter or clear the search."
      >
        {currentAppointments.map((apt) => (
          <AllusersCard 
          key={apt._id} 
          User={apt} 
          eventL={eventData.filter((ele)=>ele.userId==apt._id).length}
          horoL={horoData.filter((ele)=>ele.userId==apt._id).length}
          appointL={appointData.filter((ele)=>ele.userId==apt._id).length}
           />
        ))}
      </Ledger>
      <Pagination
        currentPage={currentPage}
        pageCount={Math.ceil(appointments.length / appointmentsPerPage)}
        onPrevious={goToPreviousPage}
        onNext={goToNextPage}
        onPage={paginate}
      />
    </>
  );
}

export default Allusers;
